var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-link',_vm._g({staticClass:"v-block-link d-flex align-items-center",attrs:{"to":_vm.to}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }